import React, { useState, useCallback, useEffect } from 'react';
import { useI18n } from '@shopify/react-i18n';
import { ActionList, Button, Popover } from '@shopify/polaris';
import localeCode from 'locale-code';

const LanguageSwitcher = ({ setLocale }) => {
	const [i18n] = useI18n();
	const [active, setActive] = useState(false);

	const supportedLanguages = [
		'de-DE',
		'en-US',
		'es-ES',
		'fr-FR',
		'it-IT',
		'nl-NL',
		'pt-PT',
		'vi-VN',
	];

	const toggleActive = useCallback(() => setActive((active) => !active), []);

	const activator = (
		<Button plain disclosure='down' onClick={toggleActive}>
			{localeCode.getLanguageNativeName(i18n.locale)}
		</Button>
	);

	const changeLocale = useCallback((locale) => {
		setLocale(locale);
		setActive(false);
	}, []);

	const languageItems = supportedLanguages.map((locale) => ({
		content: localeCode.getLanguageNativeName(locale),
		onAction: () => changeLocale(locale),
	}));

	return (
		<Popover active={active} activator={activator} onClose={toggleActive}>
			<ActionList items={languageItems} />
		</Popover>
	);
};

export default LanguageSwitcher;
